import React, { useContext, useState } from 'react';
import PerformanceBoardSettingsContext from '../contexts/PerformanceBoardSettingsContext';
import BoardContext from 'contexts/BoardContext';
import isPerformanceBoard from 'isPerformanceBoard';
import ImpersonatorContext from '../../../../contexts/ImpersonatorContext';
import CurrentUserContext from 'contexts/CurrentUserContext';

const SettingsProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { impersonatorId } = useContext(ImpersonatorContext);
  const { isFleetOpsStaff } = useContext(CurrentUserContext);
  const [navState, setNavState] =
    useState<PerformanceBoardTypes.SettingsNavState>({
      mode: isFleetOpsStaff && !impersonatorId ? 'General' : 'Fields',
    });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState<boolean>(false);
  const { board } = useContext(BoardContext);

  if (!isPerformanceBoard(board)) {
    return null;
  }

  return (
    <PerformanceBoardSettingsContext.Provider
      value={{
        navState,
        setNavState,
        hasUnsavedChanges,
        setHasUnsavedChanges,
        board,
      }}
    >
      {children}
    </PerformanceBoardSettingsContext.Provider>
  );
};

export default SettingsProvider;
